export * from './projectDeliveryStatus.service';
import { ProjectDeliveryStatusService } from './projectDeliveryStatus.service';
export * from './projectDeliveryStatus.serviceInterface';
export const APIS = [ProjectDeliveryStatusService];
